const scrollingBanner = document.querySelector(".banner-advanced");
const scrollingBannerSpeed = scrollingBanner ? parseInt(scrollingBanner.getAttribute('data-scrolling-speed'), 10) * 1000 : 5000;
const scrollingBannerAutoplayEnabled = scrollingBanner && scrollingBanner.getAttribute('data-autoplay') === 'true';
const scrollingBannerLoopEnabled = scrollingBanner.dataset.loop;

const bannerAdvancedSwiper = new Swiper(".banner-advanced.mySwiper", {
  navigation: {
    nextEl: ".banner-advanced .swiper-button-next",
    prevEl: ".banner-advanced .swiper-button-prev",
  },
  pagination: {
    el: ".banner-advanced .swiper-pagination",
    clickable: true,
  },
  autoplay: scrollingBannerAutoplayEnabled ? {
    delay: scrollingBannerSpeed, 
    disableOnInteraction: false, 
  } : false, 
  loop: scrollingBannerLoopEnabled, 
});